/* DinoStudio — AI chat widget.
   Two brains, same UI:
   - Remote mode: if a backend endpoint is configured, proxy to Claude for real LLM answers.
   - Local mode: no endpoint -> built-in smart assistant (catalog search + FAQ) runs in the browser.
   Both render replies, product cards, and execute in-chat add-to-cart via the existing Shopify cart. */
(function () {
  'use strict';
  var CFG = (window.OVERNINE && window.OVERNINE.chat) || {};
  var root = document.getElementById('onc-root');
  if (!root || !CFG.enabled) return;
  var REMOTE = !!CFG.endpoint;
  var CATALOG = CFG.catalog || [];

  var history = [];
  var opened = false, busy = false;
  var els = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { var v = parseFloat(n); return isNaN(v) ? '' : '$' + v.toFixed(2); }

  var IC_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.5 8.5 0 0 1-12.2 7.7L3 21l1.9-5.8A8.5 8.5 0 1 1 21 11.5z"/><path d="M8 10.5h8M8 14h5"/></svg>';
  var IC_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/></svg>';
  var IC_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function build() {
    var launch = document.createElement('button');
    launch.className = 'onc-launch'; launch.type = 'button'; launch.setAttribute('aria-label', 'Open chat assistant');
    launch.innerHTML = '<span class="onc-launch__btn">' + IC_CHAT + '</span>';
    launch.addEventListener('click', open);

    var nudge = document.createElement('div');
    nudge.className = 'onc-nudge';
    nudge.innerHTML = '<button class="onc-nudge__x" type="button" aria-label="Dismiss">&times;</button>Need help powering up? <b>Ask me anything ⚡</b>';
    nudge.addEventListener('click', function (e) { if (e.target.classList.contains('onc-nudge__x')) { hideNudge(); e.stopPropagation(); } else open(); });

    var panel = document.createElement('section');
    panel.className = 'onc-panel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'DinoStudio assistant');
    var hdVid = CFG.gokuVideo
      ? '<video class="onc-hd__vid" muted loop playsinline preload="none" poster="' + esc(CFG.gokuPoster || '') + '" aria-hidden="true" tabindex="-1"><source src="' + esc(CFG.gokuVideo) + '" type="video/mp4"></video><span class="onc-hd__scrim" aria-hidden="true"></span>'
      : '';
    panel.innerHTML =
      '<header class="onc-hd">' + hdVid + '<span class="onc-hd__mark" aria-hidden="true"></span>' +
        '<div class="onc-hd__meta"><div class="onc-hd__t">DinoStudio Assistant</div><div class="onc-hd__s">Online</div></div>' +
        '<button class="onc-hd__x" type="button" aria-label="Close">' + IC_X + '</button></header>' +
      '<div class="onc-body" id="onc-body"></div>' +
      '<div class="onc-ft"><textarea id="onc-input" rows="1" placeholder="Ask about tees, sizing, shipping…" aria-label="Message"></textarea>' +
        '<button class="onc-send" id="onc-send" type="button" aria-label="Send">' + IC_SEND + '</button></div>';

    root.appendChild(launch); root.appendChild(nudge); root.appendChild(panel);
    els = { launch: launch, nudge: nudge, panel: panel, body: panel.querySelector('#onc-body'),
      input: panel.querySelector('#onc-input'), send: panel.querySelector('#onc-send'), close: panel.querySelector('.onc-hd__x') };

    els.close.addEventListener('click', close);
    els.send.addEventListener('click', submit);
    els.input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); } });
    els.input.addEventListener('input', function () { els.input.style.height = 'auto'; els.input.style.height = Math.min(96, els.input.scrollHeight) + 'px'; });
    // keyboard-aware: don't let the on-screen keyboard cover the panel — dock it above the keyboard
    els.input.addEventListener('focus', function () { setTimeout(fitViewport, 60); });
    els.input.addEventListener('blur', function () { setTimeout(resetPanelSize, 140); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (els.panel.classList.contains('show')) fitViewport(); });

    try { if (!sessionStorage.getItem('onc_nudge')) setTimeout(function () { if (!opened) els.nudge.classList.add('show'); }, 3500); } catch (e) {}
  }

  function hideNudge() { els.nudge.classList.remove('show'); try { sessionStorage.setItem('onc_nudge', '1'); } catch (e) {} }
  function open() { hideNudge(); els.panel.classList.add('show'); els.launch.style.display = 'none'; if (!opened) { opened = true; addBot(CFG.greeting); renderChips(CFG.quickReplies || []); } playHeaderVideo(); }
  function close() { els.panel.classList.remove('show'); els.launch.style.display = ''; resetPanelSize(); }
  function playHeaderVideo() { var v = els.panel.querySelector('.onc-hd__vid'); if (v) { try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} } }
  function resetPanelSize() { els.panel.style.height = ''; els.panel.style.bottom = ''; }
  function fitViewport() {
    if (window.innerWidth > 520 || !window.visualViewport) { resetPanelSize(); return; }
    var vv = window.visualViewport;
    var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop); // approx keyboard height
    els.panel.style.height = Math.min(vv.height - 12, 580) + 'px';
    els.panel.style.bottom = (kb + 8) + 'px';
    scroll();
  }
  function scroll() { els.body.scrollTop = els.body.scrollHeight; }

  function addUser(text) { var d = document.createElement('div'); d.className = 'onc-msg onc-msg--user'; d.textContent = text; els.body.appendChild(d); scroll(); }
  function addBot(text) { var d = document.createElement('div'); d.className = 'onc-msg onc-msg--bot'; d.textContent = text; els.body.appendChild(d); scroll(); }
  function renderChips(list) {
    if (!list.length) return;
    var wrap = document.createElement('div'); wrap.className = 'onc-chips';
    list.forEach(function (q) { var b = document.createElement('button'); b.className = 'onc-chip'; b.type = 'button'; b.textContent = q; b.addEventListener('click', function () { wrap.remove(); sendMessage(q); }); wrap.appendChild(b); });
    els.body.appendChild(wrap); scroll();
  }
  function renderCards(cards) {
    if (!cards || !cards.length) return;
    var wrap = document.createElement('div'); wrap.className = 'onc-cards';
    cards.slice(0, 3).forEach(function (p) {
      var was = (parseFloat(p.compareAt) > parseFloat(p.price)) ? '<s>' + money(p.compareAt) + '</s>' : '';
      var card = document.createElement('div'); card.className = 'onc-card';
      card.innerHTML =
        '<a href="' + esc(p.url) + '" tabindex="-1"><img class="onc-card__img" src="' + esc(p.image) + '" alt="" loading="lazy"></a>' +
        '<div class="onc-card__mid"><a class="onc-card__nm" href="' + esc(p.url) + '" style="color:inherit">' + esc(p.title) + '</a>' +
          '<div class="onc-card__pr">' + money(p.price) + ' ' + was + '</div></div>' +
        '<button class="onc-card__add" type="button">Add</button>';
      card.querySelector('.onc-card__add').addEventListener('click', function () {
        var v = (p.variants || []).filter(function (x) { return x.available !== false; });
        var pick = v.filter(function (x) { return x.size === 'M'; })[0] || v[0] || (p.variants || [])[0];
        if (pick) { addToCart(String(pick.id), 1); }
      });
      wrap.appendChild(card);
    });
    els.body.appendChild(wrap); scroll();
  }

  var typingEl = null;
  function showTyping() { typingEl = document.createElement('div'); typingEl.className = 'onc-typing'; typingEl.innerHTML = '<i></i><i></i><i></i>'; els.body.appendChild(typingEl); scroll(); }
  function hideTyping() { if (typingEl) { typingEl.remove(); typingEl = null; } }

  function cartSummary() {
    try { if (window.CART && window.CART.state) { var c = window.CART.state(); return { item_count: c.item_count || 0, total: '$' + ((c.total_price || 0) / 100).toFixed(2) }; } } catch (e) {}
    return { item_count: (window.OVERNINE && window.OVERNINE.cartCount) || 0 };
  }
  function addToCart(variantId, qty) {
    if (window.CART && window.CART.addId) { window.CART.addId(variantId, qty || 1).then(function () { window.CART.open && window.CART.open(); }); }
    else { fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) }).then(function () { window.location.href = '/cart'; }); }
  }

  function submit() { var t = (els.input.value || '').trim(); if (t) { els.input.value = ''; els.input.style.height = 'auto'; sendMessage(t); } }

  function sendMessage(text) {
    if (busy) return;
    busy = true; els.send.disabled = true;
    addUser(text); history.push({ role: 'user', content: text });
    showTyping();
    (REMOTE ? remoteReply(text) : localReply(text))
      .then(function (data) {
        hideTyping();
        var reply = (data && data.reply) || 'Hmm, I didn’t catch that — try again?';
        addBot(reply); history.push({ role: 'assistant', content: reply });
        renderCards(data && data.cards);
        ((data && data.actions) || []).forEach(function (a) { if (a.type === 'add_to_cart' && a.variantId) addToCart(String(a.variantId), a.quantity || 1); });
        if (data && data.chips) renderChips(data.chips);
      })
      .catch(function () { hideTyping(); addBot('Sorry — something went wrong. Try again, or email support@dinostudios.co.'); })
      .then(function () { busy = false; els.send.disabled = false; if (window.innerWidth > 520) els.input.focus(); });
  }

  function remoteReply(text) {
    return fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: history, cart: cartSummary(), catalog: CATALOG }) })
      .then(function (r) { return r.json(); });
  }

  /* ---------------- Local smart-assistant engine (no backend) ---------------- */
  var SIZES = ['S', 'M', 'L', 'XL'];
  function norm(s) { return (s || '').toLowerCase(); }
  function productSearchText(p) { return norm((p.title || '') + ' ' + (p.tags || []).join(' ') + ' ' + (p.blurb || '') + ' ' + (p.handle || '')); }
  function findProducts(q) {
    var query = norm(q);
    var toks = query.split(/[^a-z0-9]+/).filter(function (t) { return t.length > 2 && ['the','and','tee','tees','shirt','shirts','with','for','your','show','add','buy','want','size','please','one'].indexOf(t) < 0; });
    if (!toks.length) return [];
    var scored = CATALOG.map(function (p) { var txt = productSearchText(p); var score = 0; toks.forEach(function (t) { if (txt.indexOf(t) >= 0) score++; }); return { p: p, score: score }; });
    scored = scored.filter(function (x) { return x.score > 0; }).sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, 3).map(function (x) { return x.p; });
  }
  function detectSize(q) { var m = norm(q).match(/\b(xl|s|m|l)\b/); if (!m) return ''; return m[1].toUpperCase(); }
  function variantFor(p, size) { var vs = p.variants || []; return vs.filter(function (v) { return v.size === size && v.available !== false; })[0] || vs.filter(function (v) { return v.size === size; })[0]; }

  function localReply(text) {
    var q = norm(text);
    var out = { reply: '', cards: [], actions: [], chips: [] };
    var matches = findProducts(q);
    var wantsAdd = /\b(add|buy|cart|purchase|get me|i want|i'?ll take|order|drop)\b/.test(q);

    // Add-to-cart intent FIRST (so "size" in an add request isn't stolen by the sizing FAQ)
    if (wantsAdd && matches.length) {
      var pp = matches[0]; var asize = detectSize(q);
      if (!asize) {
        out.reply = 'Nice pick — the ' + pp.title + '! Which size? Tap one below (they run oversized, so size down for a classic fit).';
        out.cards = [pp]; out.chips = SIZES.map(function (s) { return 'Add ' + firstWord(pp.title) + ' size ' + s; }); return delay(out);
      }
      var av = variantFor(pp, asize);
      if (!av) { out.reply = 'Size ' + asize + ' isn’t available on that one right now — try another size?'; out.cards = [pp]; return delay(out); }
      out.reply = 'Done ⚡ Added the ' + pp.title + ' in size ' + asize + ' to your cart.';
      out.actions = [{ type: 'add_to_cart', variantId: String(av.id), quantity: 1 }]; return delay(out);
    }

    // FAQ intents
    if (/\b(ship|shipping|deliver|delivery|arrive|how long)\b/.test(q)) {
      out.reply = 'Free worldwide shipping over $75 ⚡ Tees are printed to order (ships in 2–3 business days), then arrive in ~3–7 business days in the US and ~6–16 internationally — all tracked, to 60+ countries.';
      out.chips = ['Show me bestsellers', 'Returns policy'];
      return delay(out);
    }
    if (/\b(return|refund|exchange|money back)\b/.test(q)) {
      out.reply = '14-day hassle-free returns and exchanges for defects, the wrong item, or transit damage (send photos within 48h). Since tees are made to order we can’t take change-of-mind returns — but reach support@dinostudios.co and we’ll sort you out.';
      return delay(out);
    }
    if (/\b(size|sizing|fit|measurement|chest|fits?)\b/.test(q)) {
      out.reply = 'Our tees are heavyweight 7.4oz and run oversized. Rough chest/length: S 20"/27", M 22"/28", L 24"/29", XL 26"/30". Want a classic (non-oversized) fit? Size down one. Full size guide is on every product page.';
      out.chips = ['Show me bestsellers'];
      return delay(out);
    }
    if (/\b(discount|coupon|promo|code|deal|sale|cheap)\b/.test(q)) {
      out.reply = 'Season One is 33% off (tees are $39.99, down from $59.99), and code DINO10 takes an extra 10% off your first order. 🔥';
      out.chips = ['Show me bestsellers'];
      return delay(out);
    }
    if (/\b(pay|payment|secure|checkout|paypal|apple pay|card)\b/.test(q)) {
      out.reply = 'Checkout is fully secure and encrypted — Apple Pay, PayPal, and all major cards. Add what you want and hit the cart to check out.';
      return delay(out);
    }
    if (/\b(contact|email|support|help|human|agent)\b/.test(q) && !findProducts(q).length) {
      out.reply = 'You can reach a real human at support@dinostudios.co — have your order number handy and we usually reply within 24 business hours.';
      return delay(out);
    }

    // Bestsellers / new
    if (/\b(best ?sellers?|popular|top seller|bestselling|favou?rite|recommend|suggest)\b/.test(q)) {
      var best = CATALOG.filter(function (p) { return (p.tags || []).indexOf('Bestseller') >= 0; }); if (!best.length) best = CATALOG.slice(0, 3);
      out.reply = 'These are flying off the shelves 🔥 Tap Add to drop one in your cart (defaults to size M — adjust in the cart).';
      out.cards = best.slice(0, 3); return delay(out);
    }
    if (/\b(new|latest|drop|arrival)\b/.test(q)) {
      var nw = CATALOG.filter(function (p) { return (p.tags || []).indexOf('New') >= 0; }); if (!nw.length) nw = CATALOG.slice(0, 3);
      out.reply = 'Fresh drops just landed ⚡'; out.cards = nw.slice(0, 3); return delay(out);
    }

    // Add-to-cart intent
    // Product search / general match
    if (matches.length) {
      out.reply = 'Check these out ⚡ Tap Add to drop one in your cart, or ask me to add a specific size.';
      out.cards = matches; return delay(out);
    }

    // Greeting
    if (/^(hi|hey|hello|yo|sup|hola|gm|good morning|good evening)\b/.test(q)) {
      out.reply = 'Hey! ⚡ Looking for a specific character tee, or want me to show the bestsellers?';
      out.chips = ['Show me bestsellers', 'What’s my size?', 'Shipping & returns']; return delay(out);
    }

    // Fallback
    out.reply = 'I can help you find tees, answer sizing/shipping/returns, and add gear to your cart. Try a character (e.g. “Goku”, “Vegeta”), “bestsellers”, or ask about shipping.';
    out.chips = ['Show me bestsellers', 'What’s my size?', 'Shipping & returns'];
    return delay(out);
  }
  function firstWord(s) { return (s || '').split(/\s|—/)[0]; }
  function delay(out) { return new Promise(function (res) { setTimeout(function () { res(out); }, 450); }); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
